import '@babel/polyfill';
import $ from 'jquery';

function scollToTopClick() {
    if(!document.querySelector('.logo-link')) return;
    const scrollTopButton = document.querySelector('.logo-link');

    function animateScrollTop() {
    
        if(document.documentElement.scrollTop || document.body.scrollTop > 0) {
            window.scrollBy(0, -80);
            setTimeout(() => {
                animateScrollTop();
            }, 0)
        }
    }

   window.addEventListener('scroll', () => {
    if(document.documentElement.scrollTop > 500) {
        scrollTopButton.classList.add('isVisible');
    }else {
        scrollTopButton.classList.remove('isVisible');
    }
   });

   scrollTopButton.addEventListener("click", e => {
       e.preventDefault();
        animateScrollTop();
   });
}

export default scollToTopClick;